* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  --margin--compact-accordion: 0 calc(var(--spacer) * 2);
}

.gz-accordion {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
  &:focus {
    outline-offset: 0.5px;
    outline-width: 1px;
    outline-color: var(--blue-layout-501-focus);
    outline-style: solid;
  }

  &:active {
    outline: none;
  }

  .accordion-header {
    display: flex;
    justify-content: space-between;
    height: calc(var(--spacer) * 5);
    align-items: center;
    padding-left: var(--spacer);

    .title {
      font-size: var(--body-size);
      width: auto;
      text-align: start;
      color: var(--main-titles-inputs-600);
    }

    .dropdown-icon {
      height: calc(var(--spacer) * 3);
      width: calc(var(--spacer) * 3);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
    }

    &:hover {
      background: var(--chart-050-hover);
      cursor: pointer;
    }
  }

  .accordion-content {
    height: 0;
    overflow: hidden;
    color: var(--main-titles-inputs-600);

    .slot-content {
      position: relative;
      padding: 0 var(--spacer);
      --font-family: var(--font-family-secondary);
    }
  }
}

:host([isopen]) {
  .gz-accordion {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);

    &:focus {
      outline: none;
    }

    .accordion-content {
      height: 100%;
      overflow: visible;
      text-align: left;
    }

    .dropdown-icon {
      transform: rotate(180deg);
    }
  }
}

:host([iscompact]) {
  .gz-accordion {
    margin: var(--margin--compact-accordion);
  }

  .accordion-header {
    padding-left: 0;

    .title {
      color: var(--chart-300-icon-buttons);
      font-weight: 600;
      font-size: var(--body-size-small);
      text-transform: uppercase;
    }
  }

  &:host([isopen]) {
    .slot-content {
      padding: 0;
    }
  }

  &:host([hasaction]) {
    .accordion-header {
      padding-left: calc(var(--spacer) * 3);
      position: relative;

      .icon {
        visibility: hidden;
        position: absolute;
        left: 0;
        font-size: calc(var(--spacer) * 3);
      }

      &:hover {
        .icon {
          visibility: visible;
        }
      }
    }
  }
}

:host([align='left']) {
  .gz-accordion .accordion-header {
    justify-content: unset;
    .dropdown-icon {
      margin-left: auto;
    }
  }
}

:host([removeTitlePadding]) {
  .gz-accordion .accordion-header {
    padding: 0;
  }
}

$customFontSizes: 11, 12;

@each $size in $customFontSizes {
  :host([customTitleFontSize='#{$size}']) {
    .gz-accordion .accordion-header .title {
      font-size: calc(#{$size}px + var(--dynamic-font-size-changer));
    }
  }
}

.dynamic-title-content {
  font-size: var(--body-size-xxlarge);
  color: var(--main-titles-inputs-600);
}

:host([removeContentPadding]) {
  .gz-accordion .accordion-content .slot-content {
    padding: 0;
  }
}

:host([disabled]) {
  .gz-accordion {
    &:focus {
      outline: none;
    }

    .accordion-header {
      .dropdown-icon {
        cursor: not-allowed;
      }

      .title {
        color: var(--main-titles-inputs-602);
      }

      &:hover {
        background: transparent;
      }

      gz-icon::part(svgIcon) {
        fill: var(--grey-layout-202-disabled-icons);
      }

      .icon {
        visibility: visible !important;
        color: var(--grey-layout-202-disabled-icons) !important;
        cursor: not-allowed;
      }
    }
  }
}

:host([nonCollapsable]) {
  .gz-accordion {
    .accordion-header {
      cursor: default;
    }
  }
}

gz-copy-to-clipboard {
  width: auto;
  height: auto;

  &:hover {
    opacity: 0.7;
  }
}
